import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ImageFallbackDirective } from '../directives/image-fallback.directive';

@Component({
  selector: 'lib-image-list',
  imports: [ImageFallbackDirective],
  templateUrl: './image-list.component.html',
  styleUrl: './image-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageListComponent {
  images = input<Array<Array<string>>>([]);
  label = input<string>();
  calculatedHeight = input<boolean>(false);
}
